export default __webpack_public_path__ + "static/media/icon-32-icn-pickup.827ae1d7.svg";